import React, { useState } from "react";
import SeoHead from "../../../../components/SeoHead";
import BulkPaymentHero from "../../services/bulk-payment/BulkPaymentHero";
import WorkSmarter from "../../services/bulk-payment/WorkSmarter";
import WorkPayment from "../../services/bulk-payment/WorkPayment";
import JoinNetwork from "../../services/bulk-payment/JoinNetwork";
import WaterModal from "./modal/WaterModal";
import img14 from "../../../../assets/img/img14.png";
import svg120 from "../../../../assets/svg/svg120.svg";
import svg121 from "../../../../assets/svg/svg121.svg";
import svg122 from "../../../../assets/svg/svg122.svg";
import svg123 from "../../../../assets/svg/svg123.svg";
import svg116 from "../../../../assets/svg/svg116.svg";
import svg108 from "../../../../assets/svg/svg108.svg";
import svg109 from "../../../../assets/svg/svg109.svg";
import svg111 from "../../../../assets/svg/svg111.svg";
import svg112 from "../../../../assets/svg/svg112.svg";
import svg118 from "../../../../assets/svg/svg118.svg";
import svg119 from "../../../../assets/svg/svg119.svg";
import svg98 from "../../../../assets/svg/svg98.svg";

const itemsHero = [
  {
    title: "Enter Account Details",
    svg: svg98,
    desc: "Provide your water and sanitation bill account number and billing information to get started.",
  },
  {
    title: "Make Secure Payment",
    svg: svg118,
    desc: "Pay your water and sanitation bill quickly using a safe and reliable payment method.",
  },
  {
    title: "Get Instant Confirmation",
    svg: svg119,  
    desc: "Receive immediate payment confirmation and track delivery to keep your services running smoothly.",
  },
];

const itemsSmarter = [
  {
    title: "Multi-Network Support",
    svg: svg120,
    desc: "Digitized petty cash requests and approvals to remove manual handling and delays.",
  },
  {
    title: "Smarter Budgeting",
    svg: svg121,
    desc: "Monitor spending by department, set limits, and stay within budget effortlessly.",
  },
  {
    title: "Fast, Bulk Distribution",
    svg: svg122,
    desc: "Disburse funds instantly to teams and field agents, keeping operations moving.",
  },
  {
    title: "Controlled Disbursements",
    svg: svg116,
    desc: "Gain complete visibility. Every transaction is tracked, approved, and auditable.",
  },
  {
    title: "Real-Time Tracking",
    svg: svg123,
    desc: "Generate detailed reports in seconds for clear, compliant financial reviews.",
  },
];

const itemsWorkPayment = [
  {
    svg: svg108,
    title: "Fund Your Wallet",
    desc: "Add funds via bank transfer or mobile money.",
  },
  {
    svg: svg109,
    title: "Upload Recipients",
    desc: "Add phone numbers manually or import a list via Excel or CSV.",
  },
  {
    svg: svg111,
    title: "Amounts & Networks",
    desc: "Approved requests are funded instantly via wallet or linked account.",
  },
  {
    svg: svg112,
    title: "Send Instantly",
    desc: "Distribute funds instantly via water or linked account and track delivery in real time.",
  },
];

function WaterPage() {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <SeoHead
        title="Water & Sanitation Payments"
        description="Pay your water and sanitation bills quickly and securely. Never miss a payment with NdovuPay's instant bill settlement."
        path="/utility/water"
      />
      <BulkPaymentHero
        items={itemsHero}
        title="Seamless Water & Sanitation Payments"
        subtitle="Pay your water and sanitation bill quickly using a safe and reliable payment method."
        svg101={img14}
        onCtaClick={() => setOpen(true)}
        ctaLabel="Water & Sanitation Pay"
      />
      <WorkSmarter
        items={itemsSmarter}
        title="Built to Make Cash Management Effortless"
        subtitle="Go digital, save time, and stay fully in control of your operational expenses."
      />
      <WorkPayment
        items={itemsWorkPayment}
        title="How Bill Payments & Settlements Work"
        subtitle="Process all your supplier and utility payments in four simple steps"
      />
      <JoinNetwork
        title="Join the growing network of organizations using Ndovu Pay"
        subtitle="Experience the future of business payments with Ndovu Pay"
      />
      <WaterModal isModalOpen={open} handleCancel={() => setOpen(false)} />
    </div>
  );
}

export default WaterPage;
